import {AfterContentInit, AfterViewInit, Component, OnInit} from '@angular/core';
import {AppService} from '../../../services/app.service';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';
import UIkit from 'uikit';

@Component({
  selector: 'app-standard',
  templateUrl: './standard.component.html',
  styleUrls: ['./standard.component.css']
})
export class StandardComponent implements OnInit, AfterViewInit {


  constructor(
    public appService: AppService,
    public activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {

  }

  ngAfterViewInit(): void {
    if (!this.appService.islocationSetByTheUser()) {
      UIkit.modal('.citymodel').show();
    }
  }

  ngOnInit(): void {

    this.titleService.setTitle('Things2do - Home');

    this.activatedRoute.params.subscribe((params) => {
      localStorage.setItem('city', params.city);
    });

  }

}
